import { Dispatch } from 'redux';

import * as constants from '../constants';

export interface AddServerError {
    type: constants.ADD_SERVER_ERROR;
    payload: number;
}
export type ErrorAction = AddServerError;

export function addServerError(status: number = 500) {
    console.log('addServerError');
    return {
        type: constants.ADD_SERVER_ERROR,
        payload: status,
    } as AddServerError;
}
